import request from "../../utils/Request";
import {AuthEndpoints} from "./endpoints";
import header from "@/parts/Header";

const login = async (credentials: Record<string, any>) => {
  const response = await request.unauthorizedAxios().post(AuthEndpoints.AUTH_USER_LOGIN, credentials)
  return response?.data;
}

const signUp = async (data: Record<string, any>) => {
  const response = await request.unauthorizedAxios().post(AuthEndpoints.AUTH_USER_SIGN_UP, data)
  return response?.data;
}

const forgotPwd = async (data: Record<string, any>) => {
  const response = await request.unauthorizedAxios().post(AuthEndpoints.AUTH_USER_FORGOT_PWD, data)
  return response?.data;
}

const forgotPwdV2 = async (data: Record<string, any>) => {
  const response = await request.unauthorizedAxios().post(AuthEndpoints.AUTH_USER_FORGOT_PWD_V2, data)
  return response?.data;
}

const sendVerifyCode = async (data: Record<string, any>) => {
  const response = await request.unauthorizedAxios().post(AuthEndpoints.AUTH_USER_SEND_VERIFY_CODE, data)
  return response?.data;
}

const resetPasswordV2 = async (data: Record<string, any>) => {
  const response = await request.authorizedAxios().post(AuthEndpoints.AUTH_USER_RESET_PASSWORD_V2, data)
  return response?.data;
}

const userInfo = async () => {
  const response = await request.authorizedAxios().get(AuthEndpoints.AUTH_USER_INFO_URI);
  return response?.data;
}

const deleteUser = async () => {
  const response = await request.authorizedAxios().delete(AuthEndpoints.AUTH_USER_DELETE_URI);
  return response?.data;
}

const updateUserInfo = async (data: Record<string, any>) => {
  const response = await request.authorizedAxiosForm().put(AuthEndpoints.AUTH_UPDATE_USER_INFO_URI, data);
  return response?.data;
}

const userList = async () => {
  return request.authorizedAxios().get(AuthEndpoints.AUTH_USER_URI);
}

const resetPassword = async (data: Record<string, any>) => {
  return request.authorizedAxios().put(AuthEndpoints.AUTH_USER_RESET_PASSWORD, data);
}

const supportFeedback = async (data: Record<string, any>) => {
  return request.authorizedAxios().post(AuthEndpoints.AUTH_USER_SUPPORT_FEEDBACK, data, {headers:{'Content-type': 'multipart/form-data'}});
}

const firstLogin = async (data: Record<string, any>) => {
  if (data['method'] == 'post') {
    return request.authorizedAxios().post(AuthEndpoints.AUTH_USER_FIRST_LOGIN, data);
  } else {
    return request.authorizedAxios().get(AuthEndpoints.AUTH_USER_FIRST_LOGIN);
  }
}

const firstLoginByChangeLog = async (data: Record<string, any>) => {
  if (data['method'] == 'post') {
    return request.authorizedAxios().post(AuthEndpoints.AUTH_USER_FIRST_LOGIN_CHANGELOG, data);
  } else {
    return request.authorizedAxios().get(AuthEndpoints.AUTH_USER_FIRST_LOGIN_CHANGELOG);
  }
}

const getCountryList = async () => {
  return request.authorizedAxios().get(AuthEndpoints.AUTH_USER_GET_COUNTRY_LIST);
}

const getTimezoneList = async () => {
  return request.authorizedAxios().get(AuthEndpoints.AUTH_USER_GET_TIMEZONE_LIST);
}

const getTimezoneByCountry = async (data: Record<string, any>) => {
  return request.authorizedAxios().post(AuthEndpoints.AUTH_USER_GET_TIMEZONE_BY_COUNTRY, data);
}

const getVerifyCode = async (data: Record<string, any>) => {
  const response = await request.unauthorizedAxios().post(AuthEndpoints.GET_VERIFY_CODE, data, {responseType: "blob"})
  return response?.data;
}

const compliance_operation = async (data: Record<string, any>, method: any) => {
  if (method == 'GET') {
    const response = await request.authorizedAxios().get(AuthEndpoints.AUTH_USER_COMPLIANCE_OPERATION)
    return response?.data;
  } else {
    const response = await request.authorizedAxios().post(AuthEndpoints.AUTH_USER_COMPLIANCE_OPERATION, data)
    return response?.data;
  }
}

const getChatBotToken = async () => {
  const response = await request.authorizedAxios().get(AuthEndpoints.AUTH_USER_CHATBOT_TOKEN)
  return response?.data;
}

const chatBotFeedback = async (data: Record<string, any>, token: any) => {
  const response = await request.authorizedAxios().post(AuthEndpoints.AUTH_USER_CHATBOT_FEEDBACK, data,
    {headers:{'ChatBot-Token': token}})
  return response?.data;
}

const UserService = {
  login,
  deleteUser,
  userInfo,
  updateUserInfo,
  userList,
  signUp,
  forgotPwd,
  resetPassword,
  supportFeedback,
  firstLogin,
  firstLoginByChangeLog,
  getCountryList,
  getTimezoneList,
  getTimezoneByCountry,
  getVerifyCode,
  sendVerifyCode,
  resetPasswordV2,
  forgotPwdV2,
  compliance_operation,
  getChatBotToken,
  chatBotFeedback,
};
export default UserService
